module.exports = __webpack_public_path__ + "img/9791188504145.b28e0da8.jpg";